import { AnyAction } from 'redux';
import { Filter, ListItem, SearchState, SearchStateActions, Sort } from './search-model';


const InitialState: SearchState = {
	listInitialized: false,
	lists: null,
	currentLoading: true,
	filters: {},
	sortBy: null,
	appName: null,
};

const update = (filter: Filter, filters: { [key: string]: Filter }) => {
	const newFilter = { ...filters };
	newFilter[filter.filterKey] = filter;
	return newFilter;
};


export const searchReducer = (state = InitialState, action: AnyAction): SearchState => {

	switch (action.type) {

		case SearchStateActions.UPDATE_FILTER: {
			return {
				...state,
				currentLoading: true,
				filters: update(action.payload, state.filters),
			};
		}

		case SearchStateActions.INITIALIZE_LIST: {
			return {
				...state,				
				currentLoading: false,
				listInitialized: true,
				lists: action.payload,
				appName: action.appName,
			};
		}


		case SearchStateActions.START_INITIALIZE_LIST: {
			return {
				...state,
				currentLoading: true,
			};
		}

		case SearchStateActions.COMPLETE_UPDATE: {
			return {
				...state,
				currentLoading: false,
			};
		}

		case SearchStateActions.SORT_LIST: {
			return {
				...state,
				sortBy: action.payload,
			};
		}

		case SearchStateActions.CLEAR_FILTER: {
			return {
				...state,
				filters: {},
			};
		}


		default: return state;
	}
};


export const updateFilter = (filter: Filter) => {
	return {
		type: SearchStateActions.UPDATE_FILTER,
		payload: filter,
	};
};

export const initializeList = (lists: ListItem[], appName: string) => {
	return {
		type: SearchStateActions.INITIALIZE_LIST,
		payload: lists,
		appName,
	};
};


export const startInitializeList = () => {
	return {
		type: SearchStateActions.START_INITIALIZE_LIST,
	};
};


export const completeUpdate = () => {
	return {
		type: SearchStateActions.COMPLETE_UPDATE,
	};
};


export const sortList = (sort: Sort) => {
	return {
		type: SearchStateActions.SORT_LIST,
		payload: sort,
	};
};

export const clearFilter = () => {
	return {
		type: SearchStateActions.CLEAR_FILTER,
	};
};
